import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-20" }
const _hoisted_2 = { class: "text-muted ml-20" }

import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { resourceNames } from '@shell/utils/string'
import Checkbox from '@components/Form/Checkbox/Checkbox.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'applications',
  props: {
    value: {},
    names: {},
    type: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;
const store = useStore()
const t = store.getters['i18n/t'];

const deleteImage = ref(false);

const plusMore = computed(() => {
  const remaining = props.names.length - 5; //5 is the max specified in resourceNames func
  return t('promptRemove.andOthers', { count: remaining })
})

// This allows us to pass the deleteImage option to the remove function in the parent PromptRemove component
const remove = async () => {
  // Set the deleteImage flag on each application to be removed
  props.value.forEach((app: any) => {
    app._deleteImage = deleteImage.value;
  });

  //  Return false to indicate no error occurred
  return false;
}

__expose({
  remove
});


return (_ctx: any,_cache: any) => {
  const _directive_clean_html = _resolveDirective("clean-html")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createTextVNode(_toDisplayString(_unref(t)('promptRemove.attemptingToRemove', { type: _ctx.type })) + " ", 1),
    _withDirectives(_createElementVNode("span", null, null, 512), [
      [_directive_clean_html, _unref(resourceNames)(_ctx.names, plusMore.value, _unref(t))]
    ]),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Checkbox, {
        value: deleteImage.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((deleteImage).value = $event)),
        "label-key": "epinio.applications.deleteImage.label",
        class: "mb-10"
      }, null, 8, ["value"]),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('epinio.applications.deleteImage.description')), 1)
    ])
  ]))
}
}

})